<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5>
        Channel Overview
      </h5>
    </div>

    <LoadingSpinner v-if="loading" :style="loadingSpinnerStyle"/>

    <div v-else class="panel-body">
      <div class="row" v-if="result.length">
        <div class="col-xs-16">
          <ChannelTable :portal="portal" :year="year" :result="result" :target-metric="targetMetric"/>
        </div>

        <div class="col-xs-8">
          <ChannelChart :loading="loading" :result="result"/>
        </div>
      </div>

      <div v-else class="text-center text-muted" style="margin: 22px 0">
        There is no data to display!
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import ChannelChart from '@/pages/Administration/Portals/Edit/Tabs/Dashboard/Panels/ChannelOverview/ChannelChart'
import ChannelTable from '@/pages/Administration/Portals/Edit/Tabs/Dashboard/Panels/ChannelOverview/ChannelTable'

export default {
  components: {LoadingSpinner, ChannelChart, ChannelTable},

  mixins: [SaveHeight],

  props: ['year', 'portal', 'targetMetric', 'user'],

  data() {
    return {
      loading: true,

      result: null,
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    },

    portal() {
      this.load()
    },

    user() {
      this.load()
    }
  },

  computed: {
    filters() {
      return [
        {dimension: 'publish_year', operator: '=', value: this.year},
        {dimension: 'portal_id', operator: '=', value: this.portal.id}
      ]
    },

    filtersWithUser() {
      if (!this.user) {
        return this.filters
      }

      return this.filters.concat({dimension: 'user_id', operator: '=', value: this.user})
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      http.post('/api/v1/reports/channels', {
        year: this.year,
        portal_id: this.portal.id
      }).then(response => {
        this.result = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
